/**
 * Application Configuration
 * 
 * This file contains all the configuration values for the SociaLive Agency Dashboard.
 * Centralizing these values makes it easier to maintain and update the application.
 */

const appConfig = {
  // Application Information
  appName: 'SociaLive Agency Dashboard',
  
  // Parse Server Configuration
  parseServer: {
    applicationId: 'Iuuvr3phwsA6dv8iJgSA9WfFJnJ3siTUHnjRLJ5O',
    serverUrl: 'https://api.socialive.me/1/',
    javascriptKey: 'dbKfy3KJSAy14J1no7xy2uNgBTnHJTgsQfORL3Ui'
  },
  
  // App Links (web-only)
  appStoreLinks: {
    ios: 'https://socialive.me',
    android: 'https://socialive.me'
  },
  
  // Social Media Links
  socialMedia: {
    facebook: 'https://socialive.me',
    twitter: 'https://socialive.me',
    instagram: 'https://socialive.me'
  },

  // Social Login Configuration
  socialLogin: {
    facebook: {
      appId: '1604713750923624', // Facebook App ID
      version: 'v18.0'
    },
    google: {
      clientId: '984618385506-fu17hsgcpcab032rpg2p0cekerf67ibl.apps.googleusercontent.com' // Google Client ID
    },
    apple: {
      clientId: '123456789', // Apple Client ID
      scope: 'name email',
      redirectURI: window.location.origin
    }
  },
  
  // Support Information
  support: {
    email: 'socialive.me@gmail.com',
    helpCenter: 'https://socialive.me'
  },
  
  // API Endpoints
  apiEndpoints: {
    base: 'https://api.socialive.me',
    auth: '/auth',
    users: '/users',
    streams: '/streams',
    hosts: '/hosts'
  }
};

export default appConfig;
